<template>
    <div :class="`quotelines-value column-${column} / flex`">
        <div class="quotelines-value_text">
            <slot v-if="$slots.default" />
            <ShowMoreTextContent v-else :lines="3">
                <template #text-content>
                    <span v-if="richContentParsed" v-html="richContentParsed"></span>
                    <span v-else>{{ content ?? '-' }}</span>
                </template>
            </ShowMoreTextContent>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {ShowMoreTextContent} from '~/common/ui';
    import {useMarkdownToHtml} from '~/common/utils';
    import type {FixedPriceQuoteLineResource} from '~/openapi';

    const props = defineProps<{
        content?: string | number | undefined;
        richContent?: string;
        column: keyof FixedPriceQuoteLineResource;
    }>();

    const {markdownToHtml} = useMarkdownToHtml();

    const richContentParsed = markdownToHtml(props.richContent) ?? '-';
</script>

<style lang="scss" scoped>
    .quotelines-value {
        display: flex;
        width: auto;
        justify-content: flex-end;
        text-align: end;
        align-items: flex-start;
        height: 100%;
        vertical-align: top;

        &_text {
            :deep(h1) {
                font-size: var(--joy-font-size-primary-600);
            }

            :deep(span) {
                line-height: 1.1;
            }
        }

        &.column-description {
            justify-content: flex-start;
            text-align: start;
            width: 100%;
        }

        &.column-totalPriceExcludingTaxes {
            font-weight: var(--joy-font-weight-bold);
        }
    }
</style>
